import { defineMessages } from 'react-intl'

export default defineMessages({
  UserAccount_DeleteDialog_TryAgainButtonText: {
    id: 'UserAccount_DeleteDialog_TryAgainButtonText',
    defaultMessage: 'Try again',
  },
  'Redeem.pay.didntGoAsPlanned': {
    id: 'Redeem.pay.didntGoAsPlanned',
    defaultMessage: 'Something didn’t go as planned',
  },
  'Redeem.pay.contactCustomerSupport': {
    id: 'Redeem.pay.contactCustomerSupport',
    defaultMessage:
      'If you need any help, please contact support at <a>https://lifesum.com/contact</a>',
  },
})
